import {
  EqlFieldValuesAutoComplete,
  EqlFieldValuesAutoCompleteProps,
} from '@modules/common/components/EqlFieldValuesAutoComplete/EqlFieldValuesAutoComplete';
import { TextFieldProps } from '@mui/material';
import { EqlField, EqlFieldValue } from 'generated/graphql';

interface EqlValueFiltersAutoCompleteProps
  extends Omit<
    EqlFieldValuesAutoCompleteProps<false>,
    | 'multiple'
    | 'loading'
    | 'options'
    | 'onChange'
    | 'filterField'
    | 'fieldDisplayName'
  > {
  eqlField: EqlField;
  onChange: (params: {
    eqlField: EqlField;
    eqlFieldValue?: EqlFieldValue;
  }) => void;
  inputVariant?: TextFieldProps['variant'];
}

export function EqlValueFiltersAutoComplete({
  onChange,
  eqlField,
  inputVariant = 'standard',
  ...autoCompleteProps
}: EqlValueFiltersAutoCompleteProps) {
  const onValueChange = (value: EqlFieldValue | EqlFieldValue[] | null) => {
    if (Array.isArray(value)) {
      return;
    }

    onChange({ eqlField, eqlFieldValue: value ?? undefined });
  };

  return (
    <EqlFieldValuesAutoComplete
      {...autoCompleteProps}
      multiple={false}
      onChange={onValueChange}
      filterField={eqlField.field}
      fieldDisplayName={eqlField.displayName}
      inputVariant={inputVariant}
    />
  );
}
